import { parsePageData } from '../util'

export default {
  created() {
    Object.keys(this.$data)
      .filter(key => 'string' === typeof this[key] && this[key].startsWith('liquid:'))
      .forEach(key => {
        return (this[key] = parsePageData(this[key].slice(7)))
      })
  },
}
